import * as yup from 'yup'

export const registerValidationSchema = yup.object().shape({
  nik: yup
    .number()
    .test('len', 'NIK harus 16 angka', (val) => !val || (val && val.toString().length === 16))
    .nullable()
    .required()
    .typeError('Hanya bisa diisi angka'),
  nama: yup
    .string()
    .required('Mohon untuk mengisi nama anda')
    .matches(/^[A-Za-z ]+$/, 'Nama tidak bisa diisi angka atau simbol'),
  position: yup.string().required('Pilih salah satu posisi'),
  dob: yup.string().required('Mohon Pilih Tanggal Lahir'),
  jk: yup.string().required('Pilih salah satu jenis kelamin'),
  phone: yup
    .string()
    .max(13, 'Tidak bisa lebih dari 13 angka')
    .required('Mohon untuk mengisi nomor telepon/handphone anda')
    .matches(/^[0-9]/, 'Hanya boleh diisi dengan angka'),

  email: yup
    .string()
    .email()
    .matches(/^(?!.*@[^,]*,)/)
    .required('Mohon untuk mengisi email anda'),
  // .typeError('Mohon untuk mengisi email anda'),
  password: yup
    .string()
    .required('Mohon untuk mengisi password anda')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&{}])[A-Za-z\d@$!%*?&]{9,}$/,
      'Password minimal 9 karakter, terdapat 1 huruf kecil,1 huruf kapital ,1 angka dan 1 spesial karakter @$!%*?&{}',
    ),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Password tidak sama')
    .required('Mohon untuk mengisi password anda'),
})
